import React, { useState } from "react";
import Steps from "../../Steps";
import Button from "../../../../common/Button";
import ChartNav from "../../../../common/ChartNav";
import Medications from "../../medications/medications";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  classificationResultCalculation,
  GetPharmacologicalCards,
} from "./data";
import ConfirmationModalNew from "../../../../common/ConfirmationModalNew";
import { useEffect } from "react";
import {
  createMedication,
  deleteMedication,
  setClinicalServiceSteps,
  updateClinicalService,
  updateMedication,
} from "../../../../../redux/modules/clinical-services/actions";
import { ReactSVG } from "react-svg";
import NewToolTip from "../../../../common/New-ToolTip";
import MedicationCreate from "../clinical-assessment/MedicationCreate";
import PharmacologicalToolTip from "../../../../common/tooltip/minor-ailments/pharmacological";
import { pharmacologicalCards } from "./pharmacological/data";
import PharmacologicalCard from "./pharmacological/pharmacological-card";
import EndServiceModel from "../../../../common/EndServiceModel";
import SubNavigation from "../../common/sub-navigation";
import MyResults from "../other/my-results";
import { scrollX } from "../../../../../helpers/functions";
import { getValidStep, updateStepsValidity } from "../../../text/data";
import {
  AlertConfirmationTypes,
  MinorAilmentStep,
} from "../../../../../helpers/constant";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { drugTypes } from "../clinical-assessment/data";

const Pharmacological = () => {
  const { clinicalServiceObj, clinicalServiceSteps } = useSelector(
    (state) => state.clinicalService
  );
  const dispatch = useDispatch();
  const { id: patientId, serviceId } = useParams();
  const { currentStep, currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const { frequencyOfSymptoms = null, levelOfSeverity = null } =
    clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.treatment ||
    {};
  const [showMedicationSlider, setShowMedicationSlider] = useState(false);
  const [clickedMedication, setClickedMedication] = useState(null);
  const [subMedicationType, setSubMedicationType] = useState("");
  const [oralAntihistaminesPrescription, setOralAntihistaminesPrescription] =
    useState({});
  const [steroidsPrescription, setSteroidsPrescription] = useState({});
  const [combinationPrescription, setCombinationPrescription] = useState({});
  const [oralDecongestantsPrescription, setOralDecongestantsPrescription] =
    useState({});
  const [
    intranasalDecongestantsPrescription,
    setIntranasalDecongestantsPrescription,
  ] = useState({});
  const [
    addOnTherapyOralAntihistaminesPrescription,
    setAddOnTherapyOralAntihistaminesPrescription,
  ] = useState({});
  const [isCreate, setIsCreate] = useState(true);
  const [deleteMedicationPopup, setDeleteMedicationPopup] = useState(false);
  const [inEffectiveNumber, setInEffectiveNumber] = useState(0);
  const [medicationAdded, setMedicationAdded] = useState(false);
  const [showAddOnPopup, setShowAddOnPopup] = useState(false);
  const [showSkipEducationPopup, setShowSkipEducationPopup] = useState(false);
  const [continueService, setContinueService] = useState(false);
  const [isContinueClicked, setIsContinueClicked] = useState(false);
  const { showReferral } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const [showRef, setShowRef] = useState(showReferral ?? false);
  const [showAddOnTherapy, setShowAddOnTherapy] = useState(false);
  const [allowToMoveAhead, setAllowToMoveAhead] = useState(false);
  const [profileAnalysis, setProfileAnalysis] = useState(false);
  const [showProfileAnalysisCard, setShowProfileAnalysisCard] = useState(false);
  const [profileAnalysispopup, setProfileAnalysispopup] = useState(false);
  const [alertConfirmation, setAlertConfirmation] = useState(0);
  const [alertExplaination, setAlertExplaination] = useState("");

  useEffect(() => {
    if (allowToMoveAhead) {
      onNext();
      setAllowToMoveAhead(false);
    }
  }, [clinicalServiceSteps, allowToMoveAhead]);

  function getPrescriptionValue(prescription) {
    return prescription ? [prescription] : [];
  }

  const handleAddOnTherapy = async () => {
    if (!profileAnalysis) {
      if (!showAddOnTherapy) setShowAddOnPopup(true);
      else {
        await saveProgress();
        setShowProfileAnalysisCard(true);
      }
    } else setShowSkipEducationPopup(true);
  };

  const [isOverflowing, setIsOverflowing] = useState(false);
  // useEffect(() => {
  //   // Access the DOM element using the current property of the ref
  //   const myElement = document.getElementById("pharmacological");
  //   if (myElement) {
  //     setIsOverflowing(myElement.scrollWidth > myElement.clientWidth);
  //     setEnableRightArrow(true);
  //   }
  // }, [goalsData, personalGoals]);

  const [enableLeftArrow, setEnableLeftArrow] = useState(false);
  const handleLeftScroll = () => {
    const element = document.getElementById("pharmacological");
    element.scrollLeft -= 400;
    setTimeout(() => {
      // at top right scroll - scrollLeft + clientWidth will be equal to scrollWidth
      setEnableRightArrow(
        Math.ceil(element.scrollLeft) + element.clientWidth !==
          element.scrollWidth
      );
      // at top left scroll - scrollLeft will be equal to 0
      setEnableLeftArrow(element.scrollLeft !== 0);
    }, 500);
  };

  const [enableRightArrow, setEnableRightArrow] = useState(false);
  const handleRightScroll = () => {
    const element = document.getElementById("pharmacological");
    element.scrollLeft += 400;
    setTimeout(() => {
      setEnableRightArrow(
        Math.ceil(element.scrollLeft) + element.clientWidth !==
          element.scrollWidth
      );
      setEnableLeftArrow(element.scrollLeft !== 0);
    }, 500);
  };

  const getPrescriptions = async () => {
    let medicationsToSave = [];
    if (oralAntihistaminesPrescription?.medicationName) {
      medicationsToSave.push(oralAntihistaminesPrescription);
    }
    if (steroidsPrescription?.medicationName) {
      medicationsToSave.push(steroidsPrescription);
    }
    if (combinationPrescription?.medicationName) {
      medicationsToSave.push(combinationPrescription);
    }
    if (oralDecongestantsPrescription?.medicationName) {
      medicationsToSave.push(oralDecongestantsPrescription);
    }
    if (intranasalDecongestantsPrescription?.medicationName) {
      medicationsToSave.push(intranasalDecongestantsPrescription);
    }
    if (addOnTherapyOralAntihistaminesPrescription?.medicationName) {
      medicationsToSave.push(addOnTherapyOralAntihistaminesPrescription);
    }
    const medicinesToCreate = medicationsToSave.filter((med) => !med.id);
    const medicinesToUpdate = medicationsToSave.filter((med) => med.id);
    let createdMedications = {};
    let updatedMedications = {};
    if (medicinesToCreate.length > 0) {
      createdMedications = await dispatch(
        createMedication(patientId, {
          medications: medicinesToCreate,
        })
      );
    }
    if (medicinesToUpdate.length > 0) {
      updatedMedications = await dispatch(
        updateMedication(patientId, {
          medications: medicinesToUpdate,
        })
      );
    }
    let allMedications = [
      ...(updatedMedications?.medications ?? []),
      ...(createdMedications?.medications ?? []),
    ];
    const findOralAntihistaminesPrescription = allMedications.find(
      (med) =>
        med.medicationName === oralAntihistaminesPrescription?.medicationName
    );
    const findSteroidsPrescription = allMedications.find(
      (med) => med.medicationName === steroidsPrescription?.medicationName
    );
    const findCombinationPrescription = allMedications.find(
      (med) => med.medicationName === combinationPrescription?.medicationName
    );
    const findOralDecongestantsPrescription = allMedications.find(
      (med) =>
        med.medicationName === oralDecongestantsPrescription?.medicationName
    );
    const findIntranasalDecongestantsPrescription = allMedications.find(
      (med) =>
        med.medicationName ===
        intranasalDecongestantsPrescription?.medicationName
    );
    const findAddOnTherapyOralAntihistaminesPrescription = allMedications.find(
      (med) =>
        med.medicationName ===
        addOnTherapyOralAntihistaminesPrescription?.medicationName
    );

    let prescriptions = {};
    let result = classificationResultCalculation(
      frequencyOfSymptoms,
      levelOfSeverity
    );

    if (result === "Mild Intermittent") {
      prescriptions = {
        firstLineTherapyPrescriptions: getPrescriptionValue(
          findOralAntihistaminesPrescription
        ),
        stepUpTherapyPrescriptions: getPrescriptionValue(
          findSteroidsPrescription
        ),
        alternativeFirstLineTherapyPrescriptions: getPrescriptionValue(
          findCombinationPrescription
        ),
        addOnTherapyOralDecongestantsPrescriptions: getPrescriptionValue(
          findOralDecongestantsPrescription
        ),
        addOnTherapyIntranasalDecongestantsPrescriptions: getPrescriptionValue(
          findIntranasalDecongestantsPrescription
        ),
      };
    }
    if (result === "Mild Persistent") {
      prescriptions = {
        firstLineTherapyPrescriptions: getPrescriptionValue(
          findSteroidsPrescription
        ),
        addOnTherapyOralDecongestantsPrescriptions: getPrescriptionValue(
          findOralDecongestantsPrescription
        ),
        addOnTherapyIntranasalDecongestantsPrescriptions: getPrescriptionValue(
          findIntranasalDecongestantsPrescription
        ),
        addOnTherapyOralAntihistaminesPrescriptions: getPrescriptionValue(
          findAddOnTherapyOralAntihistaminesPrescription
        ),
      };
    }
    if (result === "Moderate to Severe Intermittent") {
      prescriptions = {
        firstLineTherapyPrescriptions: getPrescriptionValue(
          findSteroidsPrescription
        ),
        stepUpTherapyPrescriptions: getPrescriptionValue(
          findCombinationPrescription
        ),
        addOnTherapyOralDecongestantsPrescriptions: getPrescriptionValue(
          findOralDecongestantsPrescription
        ),
        addOnTherapyIntranasalDecongestantsPrescriptions: getPrescriptionValue(
          findIntranasalDecongestantsPrescription
        ),
        addOnTherapyOralAntihistaminesPrescriptions: getPrescriptionValue(
          findAddOnTherapyOralAntihistaminesPrescription
        ),
      };
    }
    if (result === "Moderate to Severe Persistent") {
      prescriptions = {
        firstLineTherapyPrescriptions: getPrescriptionValue(
          findSteroidsPrescription
        ),
        stepUpTherapyPrescriptions: getPrescriptionValue(
          findCombinationPrescription
        ),
        addOnTherapyOralDecongestantsPrescriptions: getPrescriptionValue(
          findOralDecongestantsPrescription
        ),
        addOnTherapyIntranasalDecongestantsPrescriptions: getPrescriptionValue(
          findIntranasalDecongestantsPrescription
        ),
        addOnTherapyOralAntihistaminesPrescriptions: getPrescriptionValue(
          findAddOnTherapyOralAntihistaminesPrescription
        ),
      };
    }

    prescriptions = {
      ...prescriptions,
      pharmacologicalSkipAddOns: showAddOnTherapy ?? false,
      //true bcz this fun will be only called when the showProfileAnalysisCard is true
      pharmacologicalProfileAnalysis: medicinesToCreate.length > 0 || medicinesToUpdate.length > 0 ? true : false,
      pharmacologicalProfileAnalysisComplete: profileAnalysis,
    };
    return prescriptions;
  };

  const onNext = async () => {
    const { nextStep, nextSubStep } = getValidStep(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      1
    );
    const treatment =
      clinicalServiceObj.initialAssessment.initialAssessmentForm.treatment;

    let updatedSteps = {
      treatment: {
        ...treatment,
        pharmacologicalConfirmationType: alertConfirmation,
        pharmacologicalExplaination: alertExplaination,
        pharmacologicalProfileAnalysisComplete: profileAnalysis,
      },
      currentStep: nextStep,
      currentSubStep: nextSubStep,
      showReferral: showRef,
      serviceSteps: clinicalServiceSteps,
    };

    dispatch(updateClinicalService(serviceId, updatedSteps));
  };

  const saveProgress = async () => {
    let prescriptions = await getPrescriptions();

    let updatedSteps = {
      treatment: prescriptions,
      currentStep: currentStep,
      currentSubStep: currentSubStep,
      showReferral: showRef,
    };

    dispatch(updateClinicalService(serviceId, updatedSteps));
  };

  const scrollAhead = (x = null) => {
    scrollX("pharmacological", x);
  };

  const onPrevious = async () => {
    const { nextStep, nextSubStep } = getValidStep(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      -1
    );
    let prescriptions = await getPrescriptions();

    let updatedSteps = {
      treatment: prescriptions,
      currentStep: nextStep,
      currentSubStep: nextSubStep,
      showReferral: showRef,
    };

    dispatch(updateClinicalService(serviceId, updatedSteps));
  };

  useEffect(() => {
    if (clinicalServiceObj.initialAssessment.initialAssessmentForm.treatment) {
      const treatment =
        clinicalServiceObj.initialAssessment.initialAssessmentForm.treatment;
      setShowAddOnTherapy(treatment?.pharmacologicalSkipAddOns);
      if (treatment?.pharmacologicalProfileAnalysis)
        setShowProfileAnalysisCard(true);
      setProfileAnalysis(treatment?.pharmacologicalProfileAnalysisComplete);
      let result = classificationResultCalculation(
        frequencyOfSymptoms,
        levelOfSeverity
      );
      if (result === "Mild Intermittent") {
        if (treatment.firstLineTherapyPrescriptions?.length > 0) {
          setOralAntihistaminesPrescription(
            treatment.firstLineTherapyPrescriptions[0]
          );
        }
        if (treatment.stepUpTherapyPrescriptions?.length > 0) {
          setSteroidsPrescription(treatment.stepUpTherapyPrescriptions[0]);
        }
        if (treatment.alternativeFirstLineTherapyPrescriptions?.length > 0) {
          setCombinationPrescription(
            treatment.alternativeFirstLineTherapyPrescriptions[0]
          );
        }
        if (treatment.addOnTherapyOralDecongestantsPrescriptions?.length > 0) {
          setOralDecongestantsPrescription(
            treatment.addOnTherapyOralDecongestantsPrescriptions[0]
          );
          setShowAddOnTherapy(true);
        }
        if (
          treatment.addOnTherapyIntranasalDecongestantsPrescriptions?.length > 0
        ) {
          setIntranasalDecongestantsPrescription(
            treatment.addOnTherapyIntranasalDecongestantsPrescriptions[0]
          );
          setShowAddOnTherapy(true);
        }
      }
      if (result === "Mild Persistent") {
        if (treatment.firstLineTherapyPrescriptions?.length > 0) {
          setSteroidsPrescription(treatment.firstLineTherapyPrescriptions[0]);
        }
        if (treatment.addOnTherapyOralDecongestantsPrescriptions?.length > 0) {
          setOralDecongestantsPrescription(
            treatment.addOnTherapyOralDecongestantsPrescriptions[0]
          );
          setShowAddOnTherapy(true);
        }
        if (
          treatment.addOnTherapyIntranasalDecongestantsPrescriptions?.length > 0
        ) {
          setIntranasalDecongestantsPrescription(
            treatment.addOnTherapyIntranasalDecongestantsPrescriptions[0]
          );
          setShowAddOnTherapy(true);
        }
        if (treatment.addOnTherapyOralAntihistaminesPrescriptions?.length > 0) {
          setAddOnTherapyOralAntihistaminesPrescription(
            treatment.addOnTherapyOralAntihistaminesPrescriptions[0]
          );
          setShowAddOnTherapy(true);
        }
      }
      if (result === "Moderate to Severe Intermittent") {
        if (treatment.firstLineTherapyPrescriptions?.length > 0) {
          setSteroidsPrescription(treatment.firstLineTherapyPrescriptions[0]);
        }
        if (treatment.stepUpTherapyPrescriptions?.length > 0) {
          setCombinationPrescription(treatment.stepUpTherapyPrescriptions[0]);
        }
        if (treatment.addOnTherapyOralDecongestantsPrescriptions?.length > 0) {
          setOralDecongestantsPrescription(
            treatment.addOnTherapyOralDecongestantsPrescriptions[0]
          );
          setShowAddOnTherapy(true);
        }
        if (
          treatment.addOnTherapyIntranasalDecongestantsPrescriptions?.length > 0
        ) {
          setIntranasalDecongestantsPrescription(
            treatment.addOnTherapyIntranasalDecongestantsPrescriptions[0]
          );
          setShowAddOnTherapy(true);
        }
        if (treatment.addOnTherapyOralAntihistaminesPrescriptions?.length > 0) {
          setAddOnTherapyOralAntihistaminesPrescription(
            treatment.addOnTherapyOralAntihistaminesPrescriptions[0]
          );
          setShowAddOnTherapy(true);
        }
      }
      if (result === "Moderate to Severe Persistent") {
        if (treatment.firstLineTherapyPrescriptions?.length > 0) {
          setSteroidsPrescription(treatment.firstLineTherapyPrescriptions[0]);
        }
        if (treatment.stepUpTherapyPrescriptions?.length > 0) {
          setCombinationPrescription(treatment.stepUpTherapyPrescriptions[0]);
        }
        if (treatment.addOnTherapyOralDecongestantsPrescriptions?.length > 0) {
          setOralDecongestantsPrescription(
            treatment.addOnTherapyOralDecongestantsPrescriptions[0]
          );
          setShowAddOnTherapy(true);
        }
        if (
          treatment.addOnTherapyIntranasalDecongestantsPrescriptions?.length > 0
        ) {
          setIntranasalDecongestantsPrescription(
            treatment.addOnTherapyIntranasalDecongestantsPrescriptions[0]
          );
          setShowAddOnTherapy(true);
        }
        if (treatment.addOnTherapyOralAntihistaminesPrescriptions?.length > 0) {
          setAddOnTherapyOralAntihistaminesPrescription(
            treatment.addOnTherapyOralAntihistaminesPrescriptions[0]
          );
          setShowAddOnTherapy(true);
        }
      }
    }
    // Access the DOM element using the current property of the ref
    const myElement = document.getElementById("pharmacological");
    if (myElement) {
      setIsOverflowing(myElement.scrollWidth > myElement.clientWidth);
      setEnableRightArrow(true);
    }
  }, [clinicalServiceObj.initialAssessment.initialAssessmentForm.treatment]);

  useEffect(() => {
    if (showAddOnPopup) {
      setIsOverflowing(true);
      setEnableLeftArrow(true);
    }
  }, [showAddOnPopup]);

  const customSubmit = async (medication, type) => {
    if (type === "firstLineOralAntihistamines") {
      setOralAntihistaminesPrescription(medication.medications[0]);
      setClickedMedication(null);
      setShowMedicationSlider(false);
      setMedicationAdded(type);
    } else if (
      type === "firstLineIntranasalCorticosteroids" ||
      type === "stepUpIntranasalCorticosteroids"
    ) {
      setSteroidsPrescription(medication.medications[0]);
      setClickedMedication(null);
      setShowMedicationSlider(false);
      setMedicationAdded(type);
    } else if (
      type === "stepUpCombination" ||
      type === "alternativeFirstLineCombination"
    ) {
      setCombinationPrescription(medication.medications[0]);
      setClickedMedication(null);
      setShowMedicationSlider(false);
      setMedicationAdded(type);
    } else if (type === "addOnTherapyOralDecongestants") {
      setOralDecongestantsPrescription(medication.medications[0]);
      setClickedMedication(null);
      setShowMedicationSlider(false);
      setMedicationAdded(type);
    } else if (type === "addOnTherapyIntranasalDecongestants") {
      setIntranasalDecongestantsPrescription(medication.medications[0]);
      setClickedMedication(null);
      setShowMedicationSlider(false);
      setMedicationAdded(type);
    } else if (type === "addOnTherapyOralAntihistamines") {
      setAddOnTherapyOralAntihistaminesPrescription(medication.medications[0]);
      setClickedMedication(null);
      setShowMedicationSlider(false);
      setMedicationAdded(type);
    }
    setProfileAnalysis(false);
    setShowProfileAnalysisCard(false);
  };

  const handlePrescribedMedication = (type) => {
    if (type === "firstLineOralAntihistamines") {
      return oralAntihistaminesPrescription;
    } else if (
      type === "firstLineIntranasalCorticosteroids" ||
      type === "stepUpIntranasalCorticosteroids"
    ) {
      return steroidsPrescription;
    } else if (
      type === "stepUpCombination" ||
      type === "alternativeFirstLineCombination"
    ) {
      return combinationPrescription;
    } else if (type === "addOnTherapyOralDecongestants") {
      return oralDecongestantsPrescription;
    } else if (type === "addOnTherapyIntranasalDecongestants") {
      return intranasalDecongestantsPrescription;
    } else if (type === "addOnTherapyOralAntihistamines") {
      return addOnTherapyOralAntihistaminesPrescription;
    }
  };

  const deleteMedicationConfirmAction = (type) => {
    setDeleteMedicationPopup(false);
    setClickedMedication(null);
    setShowMedicationSlider(false);
    if (type === "firstLineOralAntihistamines") {
      dispatch(deleteMedication(oralAntihistaminesPrescription.id));
      setOralAntihistaminesPrescription({});
    } else if (
      type === "firstLineIntranasalCorticosteroids" ||
      type === "stepUpIntranasalCorticosteroids"
    ) {
      dispatch(deleteMedication(steroidsPrescription.id));
      setSteroidsPrescription({});
    } else if (
      type === "stepUpCombination" ||
      type === "alternativeFirstLineCombination"
    ) {
      dispatch(deleteMedication(combinationPrescription.id));
      setCombinationPrescription({});
    } else if (type === "addOnTherapyOralDecongestants") {
      dispatch(deleteMedication(oralDecongestantsPrescription.id));
      setOralDecongestantsPrescription({});
    } else if (type === "addOnTherapyIntranasalDecongestants") {
      dispatch(deleteMedication(intranasalDecongestantsPrescription.id));
      setIntranasalDecongestantsPrescription({});
    } else if (type === "addOnTherapyOralAntihistamines") {
      dispatch(deleteMedication(addOnTherapyOralAntihistaminesPrescription.id));
      setAddOnTherapyOralAntihistaminesPrescription({});
    }
    setMedicationAdded(false);
    setProfileAnalysis(false);
    setShowProfileAnalysisCard(false);
  };

  const filterPharmacologicalCards = () => {
    const classification = classificationResultCalculation(
      frequencyOfSymptoms,
      levelOfSeverity
    );
    return GetPharmacologicalCards(showAddOnTherapy, classification);
  };

  const handleNext = () => {
    let treatment =
      clinicalServiceObj.initialAssessment.initialAssessmentForm.treatment;
    if (!continueService) {
      if (
        treatment?.nasalSalineRinsePrescriptions?.length === 0 &&
        treatment?.nasalSalineSprayPrescriptions?.length === 0 &&
        treatment?.nasalLubricantPrescriptions?.length === 0 &&
        !oralAntihistaminesPrescription?.medicationName &&
        !steroidsPrescription?.medicationName &&
        !combinationPrescription?.medicationName &&
        !isContinueClicked
      ) {
        setIsContinueClicked(true);
        handleAddOnTherapy();
      } else if (
        !oralAntihistaminesPrescription?.medicationName ||
        !steroidsPrescription?.medicationName ||
        !combinationPrescription?.medicationName
      ) {
        handleAddOnTherapy();
      }
    } else {
      handleAddOnTherapy();
    }
  };

  const updateStepsVisibility = (disable = false) => {
    const updatedServiceSteps = updateStepsValidity(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      disable
    );
    dispatch(setClinicalServiceSteps(updatedServiceSteps));
    setAllowToMoveAhead(true);
  };

  useEffect(() => {
    if (showAddOnTherapy) {
      scrollAhead(showProfileAnalysisCard ? 1530 : 1480);
    } else if (showProfileAnalysisCard) {
      scrollAhead(600);
    }
  }, [showAddOnPopup, showProfileAnalysisCard]);

  const disableEducationStep = (disable = false) => {
    const updatedServiceSteps = clinicalServiceSteps.map((step) => ({
      ...step,
      subSteps: step.subSteps.map((subStep) =>
        subStep.name === "Prevention Tips" ||
        subStep.name === "Education - Review Prescriptions"
          ? { ...subStep, show: !disable }
          : subStep
      ),
    }));
    dispatch(setClinicalServiceSteps(updatedServiceSteps));
    setAllowToMoveAhead(true);
  };

  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <Medications defaultExpandedSection="prescribedRx" />
          <div className="flex flex-1 w-full h-[668px] overflow-y-auto scroll-smooth ">
            <div className="w-full gap-5">
              <div className="flex items-center justify-between mt-0.5 mb-0.5">
                <h4 className="text-xs-display font-bold text-teal-300">
                  Pharmacological Treatment
                  <ReactSVG
                    src="/icons/information-dark.svg"
                    className="w-5 h-5 ml-3  inline-block"
                    data-tooltip-id="pharmacological-treatment"
                  />
                  <NewToolTip
                    id="pharmacological-treatment"
                    render={() => <PharmacologicalToolTip />}
                  />
                </h4>
                <SubNavigation />
              </div>
              <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
              <div className="flex flex-col ">
                <div className="flex justify-between">
                  <MyResults
                    frequencyOfSymptoms={frequencyOfSymptoms}
                    levelOfSeverity={levelOfSeverity}
                  />
                </div>
                <div
                  className="flex scroll-smooth mt-6 overflow-auto "
                  id="pharmacological"
                >
                  {filterPharmacologicalCards().map(
                    (pharmacological, index) => {
                      return (
                        <PharmacologicalCard
                          key={index}
                          data={pharmacological}
                          inEffectiveNumber={inEffectiveNumber}
                          isAddOn={pharmacological.cardType === "addOn"}
                          disabled={
                            pharmacological.cardType !== "addOn" &&
                            (inEffectiveNumber < index ||
                              (medicationAdded &&
                                medicationAdded !== pharmacological.type)) &&
                            !handlePrescribedMedication(pharmacological.type)
                              ?.medicationName
                          }
                          inEffectiveClick={() => {
                            setInEffectiveNumber(index + 1);
                            scrollAhead();
                          }}
                          noInEffective={
                            index + 1 === filterPharmacologicalCards().length
                          }
                          onAddClick={() => {
                            setShowMedicationSlider(true);
                            setSubMedicationType(pharmacological.type);
                            setIsCreate(true);
                          }}
                          prescribedMedication={handlePrescribedMedication(
                            pharmacological.type
                          )}
                          onEditClick={(medication) => {
                            setIsCreate(false);
                            setClickedMedication(medication);
                            setSubMedicationType(pharmacological.type);
                            setShowMedicationSlider(true);
                          }}
                          onDeleteClick={(medication) => {
                            setSubMedicationType(pharmacological.type);
                            setClickedMedication(medication);
                            setDeleteMedicationPopup(true);
                          }}
                        />
                      );
                    }
                  )}
                  {showProfileAnalysisCard && (
                    <div className="relative">
                      <div
                        className={`h-[530px] rounded-[4px] mr-10 flex flex-col relative border border-gray-100`}
                      >
                        {!showAddOnTherapy && (
                          <div className="flex flex-row justify-start rounded-s">
                            <button
                              className="m-2 h-4 w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200 text-white inline-flex border transition-all duration-300 items-center font-semibold justify-center px-2 py-4"
                              onClick={() => {
                                setProfileAnalysis(false);
                                setShowAddOnTherapy(false);
                                setShowAddOnPopup(true);
                              }}
                            >
                              <ChevronLeftIcon className="w-4 h-4 text-white" />
                            </button>
                          </div>
                        )}
                        <div className="h-[380px] w-[380px] rounded-full mx-8 mb-14 bg-blue-100 bg-opacity-40 flex items-center justify-center">
                          <ReactSVG
                            src={"/icons/profile-analysis-p1.svg"}
                            className="absolute left-[25%] top-[20%]"
                          />
                          <ReactSVG
                            src={"/icons/profile-analysis-p2.svg"}
                            className="absolute top-[25%] left-[38%]"
                          />
                          <p className="absolute bottom-[30%] text-teal-600 text-xl font-normal">
                            Powered by RxVigilance
                          </p>
                        </div>
                        <div className="mx-7">
                          {!profileAnalysis && (
                            <Button
                              className="w-full !px-2 !text-xl"
                              type="primary"
                              text="Profile Analysis"
                              onClick={() => {
                                setProfileAnalysispopup(true);
                              }}
                            />
                          )}
                          {profileAnalysis && (
                            <h4 className="text-2xl pt-4 text-REELTeal font-bold items-center justify-center flex">
                              Profile Analysis Coming Soon!
                            </h4>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {isOverflowing && (
                    <>
                      {enableLeftArrow && (
                        <button
                          className="absolute z-10 shadow-lg m-auto bg-gray-20 px-3 py-[18px] top-0 bottom-0 h-fit text-teal-600 font-bold"
                          onClick={() => handleLeftScroll()}
                        >
                          <ReactSVG
                            src="/icons/arrow-right.svg"
                            className="w-[15px] rotate-180"
                          />
                        </button>
                      )}
                      {enableRightArrow && (
                        <button
                          className="absolute z-10 shadow-lg m-auto right-0 bg-gray-20 px-3 py-[18px] top-0 bottom-0 h-fit text-teal-600 font-bold"
                          onClick={() => handleRightScroll()}
                        >
                          <ReactSVG
                            src="/icons/arrow-right.svg"
                            className="w-[15px]"
                          />
                        </button>
                      )}
                    </>
                  )}
                </div>
                <MedicationCreate
                  isRxService={true}
                  isMATreatment={true}
                  create={isCreate}
                  patientId={patientId}
                  type="Medication"
                  subType={subMedicationType}
                  open={showMedicationSlider}
                  fullMedication={clickedMedication}
                  step={1}
                  medicationName={
                    pharmacologicalCards.find(
                      (card) => card.type === subMedicationType
                    )?.subheader
                  }
                  maxSteps={1}
                  onClose={(value) => {
                    setClickedMedication(null);
                    setShowMedicationSlider(value);
                  }}
                  onSave={() => {
                    setShowMedicationSlider(false);
                  }}
                  customSubmit={true}
                  customSubmitAction={(medication, type) => {
                    customSubmit(medication, type);
                  }}
                  informationStep={true}
                  showDispenseQtyAndRefills={true}
                  selectedDrugType={drugTypes.PrescribedRx}
                />
                <ConfirmationModalNew
                  type="primary"
                  title="Add-On Therapy"
                  content={() => (
                    <div className="flex flex-col gap-4">
                      <p className="text-body-md text-gray-600 font-medium">
                        Optional additional treatments for <br />
                        <span className="font-bold">
                          {classificationResultCalculation(
                            frequencyOfSymptoms,
                            levelOfSeverity
                          )}{" "}
                          Allergic Rhinitis.{" "}
                        </span>
                      </p>
                      {classificationResultCalculation(
                        frequencyOfSymptoms,
                        levelOfSeverity
                      ) === "Mild Intermittent" ? (
                        <p className="text-body-sm text-gray-600">
                          Optional add-on medication categories do not apply for this
                          classification.
                        </p>
                      ) : (
                        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm text-gray-600">
                          <li>Oral Antihistamines</li>
                        </ul>
                      )}
                    </div>
                  )}
                  confirmText={"Continue"}
                  confirmAction={() => {
                    setShowAddOnPopup(false);
                    setShowAddOnTherapy(true);
                    setShowProfileAnalysisCard(false);
                    setProfileAnalysis(false);
                  }}
                  cancelText="Skip"
                  open={showAddOnPopup}
                  handleClose={async () => {
                    setShowAddOnPopup(false);
                    setShowProfileAnalysisCard(true);
                    setProfileAnalysis(false);
                    await saveProgress();
                  }}
                  onCross={() => {
                    setShowAddOnPopup(false);
                  }}
                />
                <ConfirmationModalNew
                  type="primary"
                  title="Education"
                  content={() => (
                    <div className="flex flex-col gap-4">
                      <p className="text-body-md text-gray-600 font-semibold">
                        Continue to Education or provide information in print
                        version only.
                      </p>
                      <p className="text-body-sm text-gray-600">
                        Storyboard available in documentation
                      </p>
                    </div>
                  )}
                  confirmText={"Continue"}
                  confirmAction={() => {
                    setShowSkipEducationPopup(false);
                    disableEducationStep(false);
                  }}
                  cancelText="Skip Education"
                  open={showSkipEducationPopup}
                  handleClose={() => {
                    setShowSkipEducationPopup(false);
                    disableEducationStep(true);
                  }}
                  onCross={() => {
                    setShowSkipEducationPopup(false);
                  }}
                />
                <ConfirmationModalNew
                  type="primary"
                  title="Delete Prescription"
                  content={() => (
                    <div className="flex flex-col gap-4">
                      <p className="text-body-md text-gray-600 font-medium">
                        Are you sure you want to delete{" "}
                        <span className="font-semibold">
                          {clickedMedication?.medicationName}?
                        </span>
                      </p>
                      <p className="text-body-sm text-gray-600">
                        This will permantently delete the prescription.
                      </p>
                    </div>
                  )}
                  confirmText={"Delete"}
                  confirmAction={() => {
                    deleteMedicationConfirmAction(subMedicationType);
                  }}
                  open={deleteMedicationPopup}
                  handleClose={() => {
                    setDeleteMedicationPopup(false);
                  }}
                  onCross={() => {
                    setDeleteMedicationPopup(false);
                  }}
                />
                <ConfirmationModalNew
                  className="!min-w-[600px]"
                  type="primary"
                  title="Profile Analysis Tool Coming Soon"
                  content={() => (
                    <div className="flex flex-col gap-4">
                      <p className="text-body-md text-gray-600 font-medium text-center">
                        Powered by RxVigilance
                      </p>
                      <p className="text-body-md text-gray-600 font-medium">
                        Profile Analysis can be used to generate numerous alerts
                        to identify potential clinical problems.
                      </p>
                    </div>
                  )}
                  confirmText={"Continue Assessment"}
                  cancelText="Cancel"
                  confirmAction={() => {
                    setProfileAnalysispopup(false);
                    setShowSkipEducationPopup(true);
                    setProfileAnalysis(true);
                  }}
                  open={profileAnalysispopup}
                  handleClose={() => {
                    setProfileAnalysispopup(false);
                  }}
                  onCross={() => {
                    setProfileAnalysispopup(false);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between space-x-4 rounded">
        <div className="w-full ">
          <Steps position="bottom" stepsList={clinicalServiceSteps} />
        </div>
        <div className="flex items-center gap-3 ">
          <Button
            type="primary-outline"
            text="Back"
            className="w-[200px] max-h-[52px] !rounded-[30px]"
            onClick={() => {
              onPrevious();
              // setShowAddOnTherapy(false);
              // setShowAddOnPopup(true);
            }}
          />
          <Button
            type="primary"
            text="Next"
            className={`w-[200px] max-h-[52px] !rounded-[30px] `}
            disabled={!profileAnalysis && showProfileAnalysisCard}
            onClick={() => {
              handleNext();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Pharmacological;
